import { lexonHttp } from "@/plugins/axios/lexonHttp";

export class ConfigurationService {
  constructor() {}

  getData(url: string) {
    return lexonHttp.get(url)
  }
}
